import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTriangleExclamation, faHandPointer } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from "react-router-dom";
import clientInformation, { getClientItem } from '../login/ClientInfo';
import { PendingPayouts } from "../../services/PayoutService";
import { useTranslations } from '../../context/LanguageContext';
import translations from '../../translations/CustomerInfoHeader';

export const CustomerInfoHeader = () => {
    const t = useTranslations(translations);
    const clientInfo = clientInformation();
    const navigate = useNavigate();
    const [arrayPendigPayouts, setPendingPayouts] = useState([]);
    useEffect(() => {
        var PayoutData = {
            "Token": getClientItem('Token')
        };
        PendingPayouts(PayoutData).then(async function (response) {
            setPendingPayouts(response.Authentication);
        })

    }, [])

    return (
        <div className="componentload">
            <div className="row">
                <div className="col-12 mt-3">
                    &nbsp;
                </div>
            </div>
            <div className="row">
                <div className="col-md-8 col-sm-12">
                    <div className="row px-md-4 py-md-3 mx-3 mb-3 alert border-orange alert alert-warning alert-white header-payout">
                        <div className="col-md-4 pr-5 text-center">
                            <div onClick={() => navigate('/payoutHistory/')} className="btn btn-squared-default-plain btn-white payout-header-text" >
                                <FontAwesomeIcon icon={faHandPointer} size="4x" beat />
                                <br />
                                {t.trackYour}
                                <br />
                                {t.withdrawal}

                            </div>
                        </div>
                        <div className=" col-md-8 pr-5 d-none d-md-block center">
                            <b>{t.trackDescription}</b>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 col-sm-12">
                    <div className="row  px-md-4 py-md-3 mx-3 mb-3 alert border-orange alert alert-warning alert-white header-payout">
                        <div className="col-12">
                            <div className="row mb-2">
                                <div className="col-6 text-left">
                                    {t.accountId}
                                </div>
                                <div className="col-6 text-right">
                                    {clientInfo.CustomerPIN}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-6 text-left">
                                    {t.balance}
                                </div>
                                <div className="col-6 text-right">
                                    {clientInfo.WithdrawalBalance}
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col-6 text-left">
                                    {t.payouts}
                                </div>
                                <div className="col-6 text-right">
                                    {arrayPendigPayouts?.PendingPayouts} {t.pending}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    )
}
